
import React, { useMemo } from 'react';
import { Shortlistedprops } from './type';
import './style.less'
import { ArrowRightOutlined } from '@ant-design/icons';

const ActiveList: React.FC<Shortlistedprops> = (props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);
    console.log(list);




    return (
        <div className="wavesummit-shortlisted">

            <div className="shortlisted-card-wrapper">
                {
                    list.map(item =>
                        <div className="wavesummit-shortlisted-all">

                            <div className="wavesummit-shortlisted-content">
                                <div className="shortlisted-bottom">
                                    <div
                                        className="shortlisted-card-img"
                                        style={{ backgroundImage: item.imageUrl ? `url(${item.imageUrl})` : undefined }}
                                    />
                                    <p className="shortlisted-title">{item.title}</p>
                                    <a href={item.btnLink}>
                                        <div className="shortlisted-link">
                                            <div className="link-look">查看详情</div>
                                            <div className="link-icon"><ArrowRightOutlined className="button-icon" /> </div>
                                        </div>
                                    </a>
                                </div>
                                <a href={item.btnLink}>
                                <div className="shortlisted-top">
                                    <div className="shortlisted-titles">{item.title}</div>
                                    <div className="shortlisted-content">{item.content}</div>
                                    <ul className="shortlisted-ul">
                                        <li className="shortlisted-btntext">{item.btnText}</li>
                                        <li><span className="shortlisted-btnlink">{item.btnLink}</span></li>
                                    </ul>
                                </div>
                                </a>
                            </div>
                        </div>

                    )
                }

            </div>

        </div>
    );
};

export default ActiveList;
